import ReduxThunk from "redux-thunk";
import axios from "axios";
import axiosMiddleware from "redux-axios-middleware";
import { configureStore } from "@reduxjs/toolkit";
import { getApiBaseUrl } from "../tools/scripts/shareHelper";
import { combineReducers } from "redux";

// old style - raw redux
//Reducers del aplicativo:
import mainReducer from './mainReducer';
import navbarReducer from './navbarReducer';
import temporalsReducer from './temporalsReducer';

// new style - redux toolkit
import pipelineReducer from "./pipelineSlice";

const rootReducer = combineReducers({
  mainReducer: mainReducer,
  navbarReducer: navbarReducer,
  temporalsReducer: temporalsReducer,
  pipeline: pipelineReducer,  
});

/*const axiosConfig = {
  baseURL: getApiBaseUrl(),
  responseType: "json",
  timeout: 1000000,
};*/

//console.log("axiosConfig:", axiosConfig);

const client = axios.create({
  baseURL: getApiBaseUrl(),
  responseType: "json",
  timeout: 1000000,
});

let logger = (getState: Function) => {
  return (next) => (action) => {
    // console.log('< ####################### >');
    // console.log('will dispatch action');
    // console.log(action);

    const returnValue = next(action);
    // console.log('< ======================= >');
    // console.log('state after dispatch');
    // console.log(getState());`

    return returnValue;
  };
};

// https://redux-toolkit.js.org/tutorials/intermediate-tutorial
// we have support for Redux DevTools now
const store = configureStore({
  reducer: rootReducer,
  middleware: [logger, ReduxThunk, axiosMiddleware(client)],
  //enhancers: [enhancer]
});
export default store;
